/*
    s_instrument.js
*/

instrumentVideoIsPlaying = false;
instrumentVideoClicked = false;

function playInstrumentVideo() {
    if(window.currentPageType == window.PAGE_TYPE_INSTRUMENTS) {
        instrumentVideoClicked = true;
        window.setTimeout( () => {
            instrumentVideoClicked = false;            
        }, 2500);
        document.getElementById('instrument-title').style.opacity = 0;
        document.getElementById('instrument-subtitle').style.opacity = 0;
        document.getElementById('instrument-title').style.filter = 'blur(20px)';
        document.getElementById('instrument-subtitle').style.filter = 'blur(20px)';
        document.getElementById('play-button-image').style.opacity = 0;
        document.getElementById('watch-trailer').style.opacity = 0;
        document.getElementById('play-button-image').style.filter = 'blur(20px)';
        document.getElementById('watch-trailer').style.filter = 'blur(20px)';
        document.getElementById('container-video-instrument').style.display = 'block';
        document.getElementById('container-video-instrument').style.opacity = '1';
        $('.cursor').css('opacity', '0');
        resetScroll();
        instrumentVideoIsPlaying = true;
    }
}

function stopInstrumentVideo() {
    if(instrumentVideoIsPlaying) {
        document.getElementById('video-instrument').src = document.getElementById('video-instrument').src
        document.getElementById('instrument-title').style.opacity = 1;
        document.getElementById('instrument-subtitle').style.opacity = 1;
        document.getElementById('instrument-title').style.filter = 'blur(1px)';
        document.getElementById('instrument-subtitle').style.filter = 'blur(1px)';
        document.getElementById('play-button-image').style.opacity = 0.8;
        document.getElementById('watch-trailer').style.opacity = 1;
        document.getElementById('play-button-image').style.filter = 'blur(1px)';
        document.getElementById('watch-trailer').style.filter = 'blur(1px)';
        document.getElementById('container-video-instrument').style.display = 'none';
        document.getElementById('container-video-instrument').style.opacity = '0';
         $('.cursor').css('opacity', '0.8');
        instrumentVideoIsPlaying = false;
    }
}


function refreshVideo() {

    if(window.currentPage == window.PAGE_PIANO) {
        if(!videoElement) videoElement = document.getElementById('text-video-guimain');
        if(!videoElement) return;

        videoRect = videoElement.getBoundingClientRect();
       
        videoPos = videoRect.top;
        videoSizeX = videoRect.height;
        windowHeight = $(window).height();
        videoPercentage = (videoPos + videoSizeX) / (windowHeight + videoSizeX);
        
        if(videoPercentage < 0) videoPercentage = 0;
        if(videoPercentage > 1) videoPercentage = 1;

        videoTarget = videoElement.duration * videoPercentage;
        if(isNaN(videoTarget)) videoTarget = 0;

        videoCurrent = lerp(videoCurrent, videoTarget, 0.2);
        videoElement.currentTime = videoCurrent;
    }
}
/*
// OLD VERSION OF THE FUNCTION:
function refreshVideo() {
    if(window.innerWidth > 1250)
        percentage = (window.scrollTop / $(window).height() - 1.7) / 2.0;
    else
        percentage = (window.scrollTop / $(window).height() - 2.5) / 2.0;
    if(percentage < 0) percentage = 0;
    if(percentage > 1) percentage = 1;
    videoCurrentTime = document.getElementById('text-video-3').duration * percentage;
    if(isNaN(videoCurrentTime)) videoCurrentTime = 0;
    document.getElementById('text-video-3').currentTime = videoCurrentTime;
}
*/

function refreshInstrumentCircle() {
    if(!instrumentCircleElement) instrumentCircleElement = document.getElementById('text-image-1');
    if(!instrumentCircleElement) return;

    circleRotateTarget = window.pos_y*window.pos_x/10000+(window.scrollTop/20);
    circleBlurTarget = Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/400;
    circleScaleTarget = 1+Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/4000;
    
    circleRotate = lerp(circleRotate, circleRotateTarget, lerpEaseSlow * 2);
    circleBlur = lerp(circleBlur, circleBlurTarget, lerpEaseSlow * 2);
    circleScale = lerp(circleScale, circleScaleTarget, lerpEaseSlow * 2);
    if(isNaN(circleRotate)) circleRotate = 0;
    if(isNaN(circleBlur)) circleBlur = 1;
    if(isNaN(circleScale)) circleScale = 1;
    if(window.scrollTop > 0 && window.scrollTop < $(window).height()*1.5) {
        instrumentCircleElement.style.transform = "translateX(-50%) translateY(-50%) rotate("+(circleRotate)+"deg) scale("+circleScale+")";
        instrumentCircleElement.style.filter = "blur("+(circleBlur)+"px)";
    } 
}

function parsePrice() {
    finalPrice = document.getElementById('final-price').innerHTML;
    finalPriceParsed = '';
    currency = '';
    for(i=0;i<finalPrice.length;i++) {
        char = finalPrice.charAt(i);
        if(char == ',') char = '.';
        // alert(char+", "+i);
        if(!isNaN(char) || char == '.') 
            finalPriceParsed += char;
        if(isNaN(char) && char != '.' && char != ' ')
            currency += char;
    }
    finalPriceParsed = parseInt(finalPriceParsed);
    if( (finalPrice.indexOf('.') != -1 || finalPrice.indexOf(',') != -1) && (finalPrice.indexOf('.00') == -1 && finalPrice.indexOf(',00') == -1) )
        finalPriceParsed += 1;
    
    
    if(document.getElementById('strike-price'))
        strikePrice = document.getElementById('strike-price').innerHTML;
    else 
        strikePrice = finalPrice;
    strikePriceParsed = '';
    for(i=0;i<strikePrice.length;i++) {
        char = strikePrice.charAt(i);
        if(char == ',') char = '.';
        if(!isNaN(char) || char == '.') 
            strikePriceParsed += char;
    }
    strikePriceParsed = parseInt(strikePriceParsed);


    document.getElementById('final-price').innerHTML = currency+finalPriceParsed;
    document.getElementById('final-price-mob').innerHTML = currency+finalPriceParsed;
    if(document.getElementById('strike-price')) {
        document.getElementById('strike-price').innerHTML = currency+strikePriceParsed;
        document.getElementById('strike-mob').innerHTML = currency+strikePriceParsed;
    }
}